import type { AdDisclosureCell, FirstFiveDaysViews } from '@discovr/types';
import { adMentionedDisplay, firstFiveDaysDisplay, type AdTone } from './firstFiveAdView';
import { HintTrigger } from '../components/common/HintTrigger';
import { cn } from '../lib/utils';

export function FirstFiveDaysCell({ cell }: { cell: FirstFiveDaysViews | undefined }) {
  const { text, progressTag, hint, muted } = firstFiveDaysDisplay(cell, new Date());
  return (
    <HintTrigger
      hint={hint}
      className="inline-flex items-center justify-end gap-1.5 whitespace-nowrap"
    >
      <span
        className={cn(
          'text-body-sm-semibold tabular-nums',
          muted ? 'text-muted-foreground' : 'text-foreground',
        )}
      >
        {text}
      </span>
      {progressTag && (
        <span className="bg-muted text-caption-medium text-muted-foreground rounded-full px-2 py-0.5">
          {progressTag}
        </span>
      )}
    </HintTrigger>
  );
}

const AD_TONE_CLASS: Record<AdTone, string> = {
  yes: 'rounded-full px-2.5 py-1 text-caption-medium bg-background-success-light-hover text-foreground-success-default',
  no: 'rounded-full px-2.5 py-1 text-caption-medium bg-stone-200 text-muted-foreground',
  not_found: 'rounded-full px-2.5 py-1 text-caption-medium bg-muted text-muted-foreground',
  unknown: 'text-body-sm-semibold text-muted-foreground',
};

export function AdMentionedCell({ cell }: { cell: AdDisclosureCell | undefined }) {
  const { label, hint, tone } = adMentionedDisplay(cell);
  return (
    <HintTrigger hint={hint} className={cn('inline-flex items-center', AD_TONE_CLASS[tone])}>
      {label}
    </HintTrigger>
  );
}
